var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{directives:[{name:"maska",rawName:"v-maska:[options]",arg:_vm.options}],staticClass:"mb-3",attrs:{"prefix":"£","label":_vm.label,"large":"","block":"","outlined":"","hide-details":"auto","rules":_vm.rules},model:{value:(_vm.currencyLocal),callback:function ($$v) {_vm.currencyLocal=$$v},expression:"currencyLocal"}})
}
var staticRenderFns = []

export { render, staticRenderFns }